<img 
alt="imagen-institucional"
[lazyLoad]="url" 
offset="700" 
defaultImage="assets/loading.svg" 
(load)="loaded($event)" 
[ngClass]="loading? 'w-0 h-0 ': class">
<content-loader [viewBox]="'0'+ ' 0 ' + width + ' ' + height" speed="3" [backgroundColor]="backgroundColor"
  [foregroundColor]="foregroundColor" *ngIf="loading">
  <svg:rect x="0" y="0" rx="2" ry="2" [attr.width]="width" [attr.height]="height" />
</content-loader>


